import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { sync } from "vuex-router-sync";
import { elementScrollIntoView } from "seamless-scroll-polyfill";
import routes from "./routes.js";

Vue.use(VueRouter);

// Создание экземпляра Router
const routerInstance = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_CLI_PUBLIC_PATH || undefined,
  routes,
  // При переходе скролить к верху страницы или к Хэшу / ID
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return {
        ...savedPosition,
        behavior: "instant"
      };
    }

    if (to.hash) {
      const element = document.getElementById(to.hash.substring(1));
      if (element) {
        elementScrollIntoView(element, { behavior: "smooth" });
        return true;
      }
    }

    // единственное что работает
    document.getElementById("app").scrollIntoView({ behavior: "instant" });

    return false;
  }
});

const middlewarePipeline = function(context, middleware, index) {
  const nextMiddleware = middleware[index];
  if (!nextMiddleware) {
    return context.next;
  }
  return () => {
    nextMiddleware({
      ...context,
      next: middlewarePipeline(context, middleware, index + 1)
    });
  };
};

routerInstance.beforeEach((to, from, next) => {
  store.dispatch("fetchEnv");

  const routeMiddleware = to.meta.middleware;
  const context = { to, from, next, store };

  if (!routeMiddleware) {
    return next();
  }

  routeMiddleware[0]({
    ...context,
    next: middlewarePipeline(context, routeMiddleware, 1)
  });
});

sync(store, routerInstance);

export default routerInstance;
